import { createContext } from "react";
import { contextAsyncFunctionInit, contextFunctionInit } from "sprint-common-web";

import { CloudFileStatus } from "../common/types/CloudFileStatus";
import { CloudFileStatusDetails } from "../common/types/CloudFileStatusDetails";
import { CloudFileListingFilters } from "./hooks/useCloudFileListingFilters";
import { CloudFileListingItem } from "./types/CloudFileListingItem";

interface ICloudFileListingContext {
    items: CloudFileListingItem[];
    selectedItems: CloudFileListingItem[];
    totalItems: number;
    setSelectedItems(selectedItems: CloudFileListingItem[]): void;
    reloadData: (filters: CloudFileListingFilters) => Promise<void>;
    repeatItemProcessing: (cloudFileId: string) => void;
    abandonItem: (cloudFileId: string) => void;
    abandonItems: (cloudFileIds: string[]) => void;
    rejectCloudFile: (cloudFileId: string) => void;
    updateCloudFileStatus: (
        cloudFileId: string,
        status: CloudFileStatus,
        statusDetails?: CloudFileStatusDetails
    ) => void;
    approveNotifications(cloudFileId: string): void;
}

export const CloudFileListingContext = createContext<ICloudFileListingContext>({
    items: [],
    selectedItems: [],
    totalItems: 0,
    setSelectedItems: contextAsyncFunctionInit,
    reloadData: contextAsyncFunctionInit,
    repeatItemProcessing: contextFunctionInit,
    abandonItem: contextFunctionInit,
    abandonItems: contextFunctionInit,
    updateCloudFileStatus: contextFunctionInit,
    rejectCloudFile: contextFunctionInit,
    approveNotifications: contextFunctionInit
});
